import { AbstractControl, FormArray, ValidationErrors, ValidatorFn } from '@angular/forms';
import { SelectedLocation } from '../Models/selectLocation.interface';
export const LAT_MIN = -90, LAT_MAX = 90;
export const LNG_MIN = -180, LNG_MAX = 180;
export interface CityLike { id: number; title: string; timeZoneId: string; }

export function latitudeValidator(): ValidatorFn {
  return (c: AbstractControl): ValidationErrors | null => {
    const v = Number(c.value);
    if (Number.isNaN(v)) return { latNaN: true };
    if (v < LAT_MIN || v > LAT_MAX) return { latRange: true };
    return null;
  };
}

export function longitudeValidator(): ValidatorFn {
  return (c: AbstractControl): ValidationErrors | null => {
    const v = Number(c.value);
    if (Number.isNaN(v)) return { lngNaN: true };
    if (v < LNG_MIN || v > LNG_MAX) return { lngRange: true };
    return null;
  };
}

export function locationValidator(): ValidatorFn {
  return (c: AbstractControl): ValidationErrors | null => {
    const v = c.value as SelectedLocation | null;
    if (!v) return { locationRequired: true };
    if (typeof v.lat !== 'number' || typeof v.lng !== 'number') return { locationInvalid: true };
    if (v.lat < LAT_MIN || v.lat > LAT_MAX) return { latRange: true };
    if (v.lng < LNG_MIN || v.lng > LNG_MAX) return { lngRange: true };
    return null;
  };
}

export function cityIdFromAutocompleteValidator(
  getSelected: () => CityLike | undefined
): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const id = control.value;
    const selected = getSelected();

    if (id == null || id === '') return { cityRequired: true };
    if (!selected || selected.id !== id) return { cityMismatch: true };
    if (!selected.timeZoneId) return { timezoneMissing: true };
    return null;
  };
}

export function requirePlantIdValidator(): ValidatorFn {
  return (g: AbstractControl) => {
    const pid = g.get('plantId')?.value;
    return pid && Number(pid) > 0 ? null : { missingPlantId: true };
  };
}

export function atLeastOneMeteringPoint(): ValidatorFn {
  return (group: AbstractControl): ValidationErrors | null => {
    const fa = group.get('meteringPoints') as FormArray | null;
    return fa && fa.length > 0 ? null : { noMeteringPoint: true };
  };
}

export function exactlyOneMain(): ValidatorFn {
  return (group: AbstractControl): ValidationErrors | null => {
    const fa = group.get('meteringPoints') as FormArray | null;
    if (!fa) return { noMeteringPoint: true };
    const mains = fa.controls.filter(c => !!c.get('isMain')?.value).length;
    return mains === 1 ? null : { mainCountInvalid: true };
  };
}